module.exports = {
  qqgdscpjypt: "世界の水産物取引所です",
  qqgdscpjypt1: "世界の水産物取引所です",
  qqgdscpjypt2: "(並びに世界ハイエンド水産物取引プラットフォームです)",
  zczh: "アカウント登録",
  yzmdl: "認証コード",
  zhmmdl: "パスワード",
  sjh: "携帯番号",
  yzm: "認証コード",
  yhylsjh: "銀行予備携帯番号",
  qsrsjh: "携帯番号を入力してください",
  qsryzm: "認証コードを入力してください",
  hqyzm: "送信",
  qsrmm: "パスワードを入力してください",
  dl: "ログイン",
  dlsb: "ログインに失敗しました",
  dlgqqcxdl: "ログインが期限切れになりました。再度ログインしてください...",
  zc: "登録",
  zcsb: "登録に失敗しました",
  yzmbnwk: "認証コードを入力してください",
  hqyzmsb: "認証コードの取得に失敗しました",
  yzmfscg: "認証コードの送信に成功しました",
  sjhbnwk: "携帯番号を入力してください",
  sjhgscw: "携帯番号の形式が正しくありません",
  mmbnwk: "パスワードを入力してください",
  mmtips:
    "パスワードは英数字と記号を組み合わせた8〜16桁である必要があります（数字のみではありません）",
  bottomcopyright1: "2023水産物取引センターICP証:京ICP備16005856号です",
  bottomcopyright2: "京公網準備11010802026156号です",
  ztsc: "テーマ市場",
  hello: "こんにちは",
  qrz: "認証に行く",
  rzhjkckjyxqy: "認証すると取引詳細ページを見ることができます",
  qkh: "口座開設に行く",
  khhjkzptwcjy: "口座開設後、プラットフォームで取引を完了できます",
  khsbxycxkh: "口座開設に失敗しました。再度開設してください。",
  qyz: "確認に行く",
  dzhyz: "アカウントの確認待ち",
  rzqyykhqlxkf:
    "認証企業が口座を開設しましたので、カスタマーサービスにお問い合わせください",
  zljyz: "データ検証中",
  shz: "審査中",
  clz: "処理中",
  dzqyz: "電子署名中",
  jnrzbzj: "入居保証金を支払う",
  jnrzbzjhkschy: "入居保証金を支払うと、貨物をアップロードできます",
  wyhyxzzycjj: "私は競売を組織したいと思っています",
  wyhyxzjmc: "私は在庫を直接販売したいと思っています。",
  yrz: "認証済み",
  hyzx: "業界ニュース",
  gd: "もっと",
  qb: "全部",
  zq: "専用エリア",
  kssj: "市場開始時間",
  ksz: "オープン中",
  xsz: "クローズ中",
  xqyzxqldsj: "月曜日から土曜日まで（祝日を除く）",
  morning: "午前9時から11時30分まで",
  zwsj: "9時00分〜16時30分",
  jjmc: "競売販売",
  jjmr: "競売購入",
  wyddxzzycjj: "注文があり、競売を開催したいと思っています。",
  gpmc: "挙手販売",
  gpmr: "挙手購入",
  wyddxsgyphy: "注文があり、一括購入したいと思っています。",
  bhtjy: "**件の取引を含む",
  bh: "包含 ",
  jyy: "条交易",

  jjkp: "すぐにオークションが始まります",
  jjks: "すぐに開始します",
  bmz: "登録中",
  jxz: "進行中",
  yjs: "終了しました",
  lp: "流れ売れ",
  wbmd: "私が参加した",
  zxsc: "最新アップロード",
  kpsj: "開催時間",
  w: "私",
  wd: "私の",
  jg: "価格",
  qpj: "スタート価格",
  dqj: "現在価格",
  cjj: "成約価格",
  yuan: "元",
  zwxgxx: "関連コンテンツはありません！",

  ryd: "**人が読む",
  qxdzcg: "いいねを取り消しました",

  bm: "登録",
  xzkhjl: "新しい見積もり記録を追加する",
  jbxx: "基本情報",
  hymc: "商品名",
  qsrhymc: "商品名を入力してください",
  dw: "単位",
  djtxdw: "単位を入力してください",
  tiao: "条",
  dun: "トン",
  zl: "重量",
  hydz: "商品の住所",
  hyzp: "商品写真",
  scp: "写真をアップロードする",
  zdjz: "（最大9枚）",
  bcqtxx: "その他の追加情報",
  bcbtj: "保存して送信する",
  cjfdxdydqjg: "入札幅度は現在価格よりも大きくする必要があります",
  fscgddmfqr: "送信に成功しました。販売者の確認を待っています。",
  cjcg: "入札に成功しました",
  cjsb: "入札に失敗しました",

  sy: "トップページです",
  rz: "認証",
  grrz: "個人認証",
  gsrz: "会社認証",
  sczj: "証明書のアップロード",
  xm: "名前",
  qsrxmxysfzbcyz: "名前を入力してください。身分証明書と一致する必要があります",
  ztlx: "主体タイプ",
  djxzlx: "クリックしてタイプを選択",
  jysx: "事業属性",
  djxzsx: "クリックしてプロパティを選択",
  jydz: "事業所在地",
  djxzdz: "クリックして住所を選択してください",
  xxdz: "詳しい住所",
  qsrxxdz: "詳しい住所を入力してください",
  jypx: "事業品目",

  djxzpx: "クリックして品目を選択",
  gsmc: "会社名",
  qsrgsmcxyyyzzyz:
    "会社名を入力してください。营业执照名称と一致する必要があります",
  qsrgsmc: "会社名を入力してください",
  lxr: "連絡先",
  qsrlxr: "連絡先を入力してください",
  qscsfz: "身分証明書をアップロードしてください",
  qscsfzwssfxx:
    "身分情報を完全にするために身分証明書をアップロードしてください",
  qpsbscndyyzz: "营业执照を撮影し、アップロードしてください",
  djscsfzzm: "身分証明書の表面をアップロードするにはクリックしてください",
  djscsfzbm: "身分証明書の裏面をアップロードするにはクリックしてください",
  djscyyzz: "营业执照をアップロードするにはクリックしてください",
  tj: "提出",
  tjrz: "認証を送信する",
  thcg: "送信に成功しました",
  tjsb: "送信に失敗しました",
  yqm: "招待コード",
  yqmxt: "招待コード（オプション）",
  qtxyqm: "招待コードを入力してください",
  sryqmrwkbt: "招待コードを入力してください。ない場合は空白でかまいません",
  qd: "確定",
  qx: "キャンセル",
  sctpyc: "画像のアップロードに異常が発生しました",
  sfzxmysrxmbyzqcxtr:
    "身分証明書の名前と入力された名前が一致しません。再度入力してください～",
  yyzzmcysrmcbtzqcxtx:
    "营业执照の名称と入力した名称が一致しません。再度入力してください～",
  tpsbycqcxsc:
    "画像認識の異常が発生しました。アップロードされた画像情報を確認してください。",
  rzsb: "認証に失敗しました",
  rzyc: "認証に異常が発生しました",
  qsryqm: "招待コードを入力してください",

  grzx: "マイページ",
  zhye: "アカウント残高",
  wdye: "私の残高",
  ljczlc: "チャージフローを理解する",
  tx: "引き出す",
  bccg: "保存に成功しました",
  bcsb: "保存に失敗しました",
  bcyhcw: "ユーザーエラーを保存する",
  txtp: "プロフィール画像",
  bdsjh: "携帯番号をバインドする",
  hb: "再バインド",
  dlmm: "ログインパスワード",
  qsz: "設定に移動",
  xgmm: "パスワードを変更する",
  szmm: "パスワードを設定する",
  qr: "確認",
  djscndtx: "あなたのプロフィール画像をアップロードしてください",
  hbsjh: "携帯番号を再バインドする",
  qsrhbsjh: "再バインドする携帯電話番号を入力してください",
  dqsjh: "現在の携帯番号",
  ghcg: "変更に成功しました",
  xgcg: "変更に成功しました",
  szcg: "設定に成功しました",
  uploatips: "アップロードされるファイルのサイズは5MBを超えることはできません",
  success: "成功しました",
  fail: "失敗しました",

  zhmx: "アカウント明細",
  mj: "売り手",
  maij: "買い手",
  dj: "凍結",
  djmx: "凍結明細",
  yjcdj: "凍結が解除されました",
  zrtxje: "振り込み引き出し明細",
  pfmx: "支払明細",

  rzbzj: "入居保証金",
  bzjtips:
    "売り手の顧客が取引を開始する場合、入居保証金は100万元以上でなければなりません。",
  bzjtips1: "試験運用段階では、この規定はまだ実施されていません。",
  zcdz: "送金",
  zrdz: "振り込み",

  qrcj: "入札を確認する",
  hpmc: "商品名",
  zxjg: "最新価格",
  ykj: "一口価格",
  jpcj: "オークション入札価格",
  cjf: "入札者",
  dunshu: "トン数",
  zdbmds: "最低応募トン数",
  grds: "購入トン数",
  cjje: "入札金額",
  qsrndgrds: "購入トン数を入力してください",
  qsrndcjje: "入札金額を入力してください",

  wddd: "私の注文",
  hyd: "貨源地",
  shd: "受取地",
  djkckmfhy: "クリックして売り手の商品情報を表示できます",
  hyzj: "商品総額",
  djtips: "頭金（履行保証金で支払いを相殺）",
  fwf: "サービス料",
  wk: "残額",
  ddbh: "注文番号",
  copy: "コピー",
  cjsj: "作成日",
  mffk: "購入者の支払い",
  ccbg: "出荷報告書",
  zskf: "専属カスタマーサポート",
  hckf: "華彩カスタマーサポート",
  dfpkf: "品質管理の割り当て待ち...",
  lxpk: "品質管理に連絡する",
  qfk: "支払いに行く",

  txmfhy: "売り手商品情報を入力する",
  ckmfhy: "売り手商品情報を表示する",
  hyxx: "商品情報",
  ddxx: "注文情報",
  ksrbcne: "追加情報を入力できます...",
  bt: "必須",
  xt: "任意",
  fsgmf: "購入者に送信する",

  sztx: "リマインダーを設定する",
  sztxcg: "リマインダーを設定しました",
  qxtxcg: "リマインダーをキャンセルしました",
  szsb: "設定に失敗しました",
  qxbmcg: "応募をキャンセルしました",
  ysz: "設定済み",
  jjs: "終了まで",
  jks: "開始まで",
  sc: "時間",
  kdjckkhjl: "商品履歴を確認するにはクリックしてください",
  bm10sr: "**人が応募しました",
  wg10ren: "**回見学されました",
  jybh: "取引番号",
  jplx: "オークションタイプ",
  jjfd: "価格上昇幅",
  jjfdjj: "価格低下幅",
  jpsj: "オークション時間",
  jpsc: "オークション期間",
  fz: "分",
  yszq: "遅延サイクル",
  jylx: "取引タイプ",
  scsj: "アップロード時間",
  lxdh: "連絡先電話番号",
  ppxq: "商品の詳細",
  pkbb: "品質管理報告書",
  cjjl: "入札履歴",
  xqms: "要求の説明",
  hyms: "商品の説明",
  jjr: "入札者",
  sj: "時間",
  ckgd: "もっと見る",
  zwcjjl: "入札履歴はありません",
  smewmdsj: "スマートフォンにQRコードをスキャンしてください",
  dqrp: "現在のホットオークション",
  yhwrzqdgezxrz:
    "ユーザーが認証されていません。個人センターに移動して認証してください。",

  ckkhxx: "商品情報を見る",
  lsjl: "履歴",
  bmcg: "応募成功",
  dmfqr: "購入者の確認待ち",
  mfjj: "購入者に拒否されました",
  mfcswcl: "購入者が処理しなかった場合のタ",
  bj: "編集",
  delete: "削除",
  qrxgfsgmf: "変更を確認して購入者に送信する",
  qrscgkhxx: "この商品情報を削除しますか？",
  sccg: "削除しました",
  ldfs: "冷凍方式",
  jjsz: "入札設定",
  jjrq: "入札日",
  djxzjjrq: "クリックして入札日を選択",
  jjsj: "入札時間",
  djxzjjsj: "クリックして入札時間を選択",
  jjsc: "入札期間",
  djxxjjsc: "クリックして入札期間を選択",
  srsz: "数字を入力してください",
  gpsz: "リストに表示",
  jgsz: "配達設定",
  yf: "送料",
  djlybzj: "履行保証金を凍結する",
  tjhddsh: "提出後、審査待ちです",

  bmlb: "応募リスト",
  dqr: "確認待ち",
  yjj: "拒否されました",
  yqr: "確認済み",
  bmbh: "応募番号",
  bmsj: "応募日時",
  sfjjbm: "応募を拒否しますか？",

  syrzbzjy: "残りの入居保証金（元）",
  rzbzjtips1:
    "売り手のお客様が取引を開始した場合、入居保証金は100,000元以上である必要があります",
  zrje: "金額を振り込む",
  qsrzrje: "金額を入力してください",
  qbzr: "すべて振り込む",
  yczr: "ここから振り込む",
  zrcg: "振り込みに成功しました",
  zrsb: "振り込みに失敗しました",

  zcje: "振り出し金額",
  qsrzcje: "振り出し金額を入力してください",
  qbzc: "すべて振り出す",
  zcz: "振り出し先",
  zccg1: "振り出しに成功しました",
  zcsb1: "振り出しに失敗しました",

  ktzfzh: "支払いアカウントを開設する",
  grkh: "個人口座開設",
  qykh: "企業口座開設",
  gtgshkh: "個人事業主口座開設",
  khsb: "口座開設に失敗しました",
  wdyhk: "私の銀行カード",
  yjhb: "一括変更",
  bdyhk: "銀行カードをバインドする",
  zhlx: "アカウントタイプ",
  qdjxz: "クリックして選択してください",
  dgzh: "法人",
  dszh: "個人",
  ckr: "カード名義人",
  qsrckrxm: "カード名義人の名前を入力してください",
  qsrxm: "名前を入力してください",
  yhkh: "銀行カード番号",
  qsrkh: "カード番号を入力してください",
  khh: "口座開設行",
  qsrkhh: "口座開設行を入力してください",
  zcyh: "対応銀行",

  wfbd: "私の投稿",
  wdjy: "私の取引",
  wgzd: "私の注目",
  qtgn: "その他の機能",

  yx: "メールアドレス",
  dz: "住所",
  kfzsewm: "カスタマーサポート専用QRコード",
  qtxzgcyhdwzs: "中関村銀行が指定の法人口座に送金する金額を入力してください",
  skjey: "受取金額（元）",
  ytjqnxddsh: "提出済み、審査待ちです！",

  yey: "残高（元）",
  txje: "引き出し金額",
  qsrtxje: "引き出し金額を入力してください",
  qbtx: "すべて引き出す",
  dzyhk: "入金先銀行カード",

  jjcj: "競り入札価格",
  ydzdcj: "最低価格に到達しました",
  zklyx: "最新価格",
  jjcg: "競りに成功しました",
  jyts: "取引のヒント",
  qrybdyhk: "銀行カードがバインドされていることを確認してください",
  syysyhkxrxzhhk:
    "上記の銀行カードを使用して、以下のアカウントに送金してください",
  zhm: "アカウント名",
  zhzh: "アカウント番号",
  zhc: "張華采",
  bjyhzgczh: "北京中関村銀行株式会社",
  xzf: "支払いが必要です",
  wkyf: "残金支払い金額",
  xzzffs: "支払い方法を選択してください",
  wdzh: "私のアカウント",
  qrzf: "支払いを確認する",
  zhyebzljzr:
    "アカウントの残高が不足しています。入金について確認してください。",
  zfcg: "支払いが成功しました",
  bmxz: "申し込みの注意事項",
  dqbdlybzj: "現在の契約保証金",
  ndzhye: "あなたのアカウント残高",
  bmjjjbstyxydjbzj:
    "申し込み入札は、対応する契約保証金を凍結することに同意することを意味します",
  rwhpjth: "入札に失敗した場合、凍結された契約保証金は自動的に解除されます",
  rcgzcdhk:
    "入札に成功した場合、凍結された契約保証金は、残金支払い時に定金として使用されます",
  rcgpxjkc:
    "入札に成功した後、契約を履行しない場合、凍結された保証金は差し引かれます",
  zhyebzwfbm: "アカウント残高が不足しているため、申し込みできません",
  qzr: "入金に移動する",
  qrbm: "申し込みを確認する",

  zd: "移動",
  ye: "ページ",

  scxgzj: "関連証明書をアップロードする",
  qscyyzz: "营业执照をアップロードしてください",
  yyqx: "营业期限を入力してください",
  qsryyqx: "登録住所を入力してください",
  zcdz1: "統一社会信用代码を入力してください",
  qsrzcdz: "组织机构代码证をアップロードしてください",
  tyshxydm: "クリックして组织机构代码证をアップロードする",
  qsrtyshxydm: "组织机构代码を入力してください",
  qsczzjgdmz: "组织机构代码证の期限を入力してください",
  djsczzjgdmz: "税务登记証をアップロードしてください",
  zzjgdm: "クリックして税务登记証をアップロードする",
  qsrzzjgdm: "税务登记証のコードを入力してください",
  zzjgdmzqx: "法人身份証をアップロードしてください",
  qsrzzjgdmzqx: "身份证号を入力してください",
  qscswdjz: "身份证の有効期限を入力してください",
  djscswdjz: "クリックして税務登録書をアップロードしてください。",
  swdjzdm: "税務登録書コード",
  qscfrsfz: "法人身分証明書をアップロードしてください。",
  sfzh: "身分証明書番号",
  qsrsfzh: "身分証明書番号を入力してください。",
  sfzyxq: "身分証明書の有効期限",
  qsryxq: "有効期限を入力してください。",
  qsclxrsfz: "連絡者の身分証明書をアップロードしてください。",
  lxrxm: "連絡者の名前",
  lxrsfzh: "連絡者の身分証明書番号",
  lxrsjh: "連絡者の携帯電話番号",
  qsrlxrsjh: "連絡者の携帯電話番号を入力してください。",
  lxryx: "連絡者のメールアドレス",
  qsrlxryx: "連絡者のメールアドレスを入力してください。",
  zhmc: "アカウント名",
  qsrzhmc: "アカウント名を入力してください。",

  wdfb: "私のリリースです",
  tcdl: "ログアウトします",
  smjrxcx: "スキャンしてウィジェットに入れます",
  czgjfbkj: "操作が便利になりました",
  ss: "検索します",
  tgsh: "審査に合格します。",
  js: "終わります",
  bohui: "却下します",
  scdd: "生成します",
  xgjg: "価格を変更します",
  qdgj: "改定を確定します。",
  xjhyyy: "撤去します",
  bmhy: "商品を申し込みます。",
  ckdd: "註文を見ます",
  pkdh: "品管理電話です",
  bmdjj: "申し込みの入札です",
  bmdgp: "申し込みの掲示",
  dzdwz: "いいねを押した記事です",
  mairu: "買います",
  maichu: "売ります",
  grxx: "個人情報です",
  grsy: "トップページです",
  quhao: "市外局番です",
  dfk: "支払い待ちです",
  djg: "受渡し待ちです",
  ywc: "完成しました",
  qt: "その他です",
  dsh: "審査待ちです",
  zsz: "展示中です",
  nhqdl: "こんにちはログインお願いします",
  mfzc: "登録は無料です",

  jyzx: "取引します",
  hyzx11: "ニュースです",
  qgsj: "全国です",
  qqsj: "全世界です",
  cczx: "サービスです",
  gzzx: "ルールです",
  lxwm: "連絡します",
  sjzx: "値段です",
  grzxxx: "個人です",

  szgjjqyjyzx: "深セン国際マグロ取引センターです",
  qqgdscpjyzx: "世界の水産物取引所です",
  djjrjyzx: "クリックして取引所に行きます",
  gjst: "共に生態系を構築します",
  hzgyy: "協力はウィンウィンです",
  gongsijieshao: "会社紹介です",
  pingtaijieshao: "プラットフォームの紹介です",
  dazaoqqzddyyjypt: "世界のハイエンド水産物のオンライン取引センターを作ります",
  gsjstips111:
    "中国農業発展集団傘下の中水集団遠洋股份有限公司が発起し、華採科技(北京)有限公司が技術と専門的なサポートを提供します。",
  lliaojiexiangq: "詳細を瞭解します",
  guankanship: "ビデオを見ます",
  xianshangjiaxianxia: "「オンライン」+「オフライン」です",
  gsjstips222:
    "同社は世界のハイエンド水産物オンライン取引センターの構築に力を入れており、「オンライン」+「オフライン」の双発エンジンで駆動し、遠隔地のハイエンド水産物のデジタル化取引センターと現場のオークション取引を連動させます。",
  sjzgrdbzsrjg: "中国人のタンパク質摂取の仕組みを進化させました",
  gsjstips333:
    "大きな食物観をもとに指導し、生態系の共同建設、協力・ウィンウィンを理念とし、科学技術を手段としてハイエンド水産物産業のデジタル化プロセスを推進し、世界のハイエンド水産物の取引・流通の効率を高め、中国人のタンパク質摂取構造をアップグレードし、世界のハイエンド水産物デジタル化の新しい生態系を再構築します。",
  gaoduanshuichanpzonghefuwupingtai:
    "ハイエンド水産物総合産業サービスプラットフォームです",
  gsjstips444:
    "深圳市政府の承認を経て、中国農業発展集団と深圳港集団が共同で発起し、北京華採が技術支援を提供します。深セン国家遠洋漁業基地の先導プロジェクトとして運営に入ります。センターは2023年5月12日に正式にサービスを開始します。ハイエンド水産物の現物取引を中心に、水産物の標準制定、新品種の研究開発・普及、市場情報サービス、技術サービス、金融サービス、物流サービスを一体化したハイエンド水産物総合産業サービスセンターです。",
  pingtai1: "世界のマグロ取引の中心都市を網羅しています",
  pingtai2:
    "センターは深センをハブとして、大連、煙台、舟山、東京、高雄、バンコクなどの世界的に重要なマグロの集散地を結び、受渡し倉庫を設立し、世界的な受渡しを実現します。センターにはマグロ以外にも、銀鱈、サーモン、ズワイガニ、ロブスターなどの高級水産物が含まれています。",
  pingtai3: "国際化、標準化、情報化、デジタル化です",
  pingtai4:
    "センターは世界のハイエンド水産物産業の革新とアップグレードを推進し、水産物取引の国際化、標準化、情報化とデジタル化を実現します。センターは強力な市場化の運営能力、資源の整合能力及び優遇の政策の付帯資源を利用して、アジア太平洋地域の国際ハイエンド水産物の取引、決済、価格設定センターを段階的に完成します。",
  adv1: "私たちの強みです",
  adv2: "クラウド取引、世界受渡し、独占資源、深セン価格です",
  adv3: "ハイエンドです",
  adv4: "効率的です",
  adv5: "高品質です",
  adv7: "高品質です",
  adv6:
    "アジア太平洋地域のハイエンド水産取引センター、決済センター、価格設定センターを作ります",
  cloud1: "クラウド取引です",
  cloud2: "グローバル受渡しです",
  cloud3: "資源を独占することです",
  cloud4: "深セン価格です。",
  cloud5: "全行程をトレースします。",
  cloud6: "AI検査です",
  cloud7: "データエンジンです",
  cloudIntro1:
    "クラウド上の取引、全世界を買って、全世界を売って、取引は無限に達します",
  cloudIntro2:
    "グローバル受渡し、世界の主要集散地の都市の現地受渡し、物流コストを削減します。",
  cloudIntro3: "資源の独占,遠洋クロマグロの全量割当,販売ルート指定です",
  cloudIntro4:
    "深センの価格は世界のマグロの集散地の都市の実際の取引価格を発表して、中国市場の価格決定センターの地位の確立に助力します",
  cloudIntro5:
    "製品の全行程をトレースして、製品の真実の情報を還元して、1魚1ヤード、100%の食用の安全を実現します",
  cloudIntro6:
    "AI画像認識は品制御能力を強化し、検査基準の統一により従来の験魚誤差を低減し、多シーン応用効率を高めます。",
  cloudIntro7: "データエンジンビッグデータマイニングで意思決定の精度を高めます",
  gsdzzzzz: "会社の住所:北京市朝陽区八里荘陳家林9号院華騰世紀総部公園E1座601A",
  xcxxxx: "ミニプログラムです",
  fwhhhh: "サービス番号です",
  wzdhhh: "webナビゲーションです",
  pzzx: "受渡しです",
  login1: "共創生態協力とウィンウィン",
  login9: "ハイテクによるハイエンド水産物のデジタル化プロセスの推進",
  login11: "今すぐログイン",
  person1: "トップページです",
  person2: "個人情報です",
  person7: "口座開設の流れです",
  qkk: "見てみます",
  wfbdjy: "取引します",
  rxtel: "電話です",
  kfrxxx: "電話です",
  gzsjjj: "労働時間です",
  jqy: "マグロです",
  qtpl: "その他のカテゴリーです",
  cjjjj: "成約です",
  qpppp: "スタートです",
  plll: "カテゴリーです",
  pxxx: "アイテムです",
  jqyfl: "マグロの分類です",
  zzjx: "進行中です",
  jssj: "終了時間です",
  ysztx: "リマインダーを設定しました",
  dpsjgzg: "大画面です",
  cdxx: "生産地情報です",
  ggzbjdx: "規格の比率と大きさです。",
  hours: "時間です",
  minus: "分です",
  second: "秒です",
  wxsys: "微信でチェックしてみます。",
  service1: "どんなサービスがありますか",
  service2: "当社のサービス全体で事業成長を実現します。",
  service3: "金融サービスです",
  service4:
    "上下流の顧客に全方位的な金融支援を提供し、資金繰りの難題を解決し、取引の効率を高め、取引コストを下げることを目的としています。",
  service5: "全面的です",
  service6: "物流サービスです",
  service7:
    "上下流の顧客に効率的で便利な物流サポートを提供し、取引と物流配送をよりよく完成させることを目的としています。",
  service8: "効率的です",
  service9: "データサービスです",
  service10:
    "上下流のお客様に全面的で、タイムリーで、正確な取引データと市場情報を提供することを目的としています。彼らが市場の働態と傾向を理解し、より賢明な取引の意思決定をするのを助けます。",
  service11: "専門です",
  service12: "全面的に理解しています",
  service13:
    "融資サービス、決済サービス、リスク管理サービスなどを含め、上下流の顧客に全面的な金融サポートを提供し、資金繰りの難題を解決し、取引の効率を高め、取引のコストを下げることを目的としています。また、金融サービスをさらに開拓し、金融商品革新センターを設立するなど、上下流の顧客により全面的で専門的な金融サービスを提供する予定です。",
  service14:
    "倉庫サービス、配送サービス、通関サービス、保険サービスなどを含み、上流と下流の顧客に効率的で便利な物流サポートを提供し、取引と物流配送をよりよく完成させることを目的としています。物流情報プラットフォームの構築、物流管理SAASツールの開発など、物流サービスをさらに拡大し、上流・下流の顧客により全面的で効率的な物流サポートを提供する計画です。",
  service15:
    "リアルタイムの相場データ、取引データの分析、市場情報の発表、データのカスタマイズサービスなどを含み、上下流の取引先に全面的で、タイムリーで、正確な取引データと市場情報を提供することを目的としており、彼らが市場の働態と傾向を理解し、より賢明な取引の意思決定を下すことを助けます。センターはデータサービスをさらに開拓して、データセンターの設立、データ分析ソフトウェアの開発などを含んで、上下流の顧客に更に全面的で専門的なデータサポートを提供します。",
  slx: "数(箱)です。",
  cdmc: "産地名です",
  rknf: "入庫年です",
  rkyf: "入庫月です",
  ggzbjdxplace:
    "商品の出所が含む規格の割合と大きさの情況を書き出してください、例えば:規格の100-150は25%を占めて、やや大きいです;規格200-3000比率75%,通常サイズです",
  rules1: "世界の水産物取引プラットフォームのルールまとめ(試用)です。",
  rules2: "第1章総則です",
  rules3: "第一条です",
  rules4:
    "世界の大口水産物取引プラットフォームのオンライン取引規則(以下、本プラットフォームという)を規範化し、市場秩序を維持し、会員の合法的権益を保障するため、「中華人民共和国民法典」、「中華人民共和国競売法」、「第三者電子商取引センターサービス規範」などの関連法律法規などの規定に基づき、本細則を制定します。",
  rules5: "第二条です",
  rules6:
    "このルールは世界の水産物の大口取引プラットフォームでの取引に適用されます。トレーディングセンターのすべてのスタッフ、会員、マーケットメーカー、納入倉庫及び関系協力机関はこの規則を守らなければなりません。",
  rules7: "第二章取引です",
  rules8: "第3条営業時間です",
  rules9: "1.月曜日から土曜日まで:毎日9:00-16:30;",
  rules10: "2.日曜日と祝日は営業しません。",
  rules11: "第四条料金基準です",
  rules12:
    "買い手と買い手は取引方法や品目によって異なる料金を支払うことになりますが、詳細は「プラットフォーム料金」を参照してください。",
  rules13: "キャラクターです",
  rules14: "買い手です",
  rules15: "売り手です",
  rules16: "取引モデルを開始します",
  rules17: "取引ルールです",
  rules18:
    "買い手は購入ニーズをアップロードしてスタート価格を設定し、売り手は買い手のニーズに応じて入札を行います。",
  rules19:
    "買い手は買いたいという欲求をアップロードして、価格や数量などのハードルを設定し、売り手はそれに合わせて売ります。",
  rules20:
    "売り手は売り物をアップロードしてスタート価格を設定し、買い手は売り手の要求に応じて入札します。",
  rules201:
    "売り手は商品の出荷先の明細をアップロードし、開始価格を設定し、買い手は売り手の需要に応じて入札を行います。",
  rules21:
    "売り手は商品の明細を掲載して価格や数量などのハードルを設定し、買い手は売り手の商品の状況に応じて購入します。",
  rules22: "センター料金体系です",
  rules23: "(暫定です)",
  rules24: "取引に参加するバイヤーはサービス料100元/トンを受け取ります。",
  rules25: "取引に参加する売り手は5‰の手数料を受け取ります。",
  rules26: "保証金です",
  rules27:
    "取引証拠金:買い手はまず、代金の20%の取引証拠金を手付金として納めなければなりません。成約後、この手付金が代金に充当されます。",
  rules28: "テナント入店センター保証金100000元です",
  rules29: "支払いと出荷の時期です",
  rules30: "註文後24時間以内に代金を支払います。",
  rules31: "(期限が過ぎた場合はセンターまで連絡します)",
  rules32: "買い手が全額を支払ってから48時間以内に出荷します。",
  rules33: "五条です",
  rules34:
    "オファーの貨幣種は人民元で、オファーの単位は品目の要求によって具体的に設定します。",
  rules35: "第六条です",
  rules36:
    "すべてのユーザーは、プラットフォーム上の取引家としての手付金を支払う必要がありますが、通常の販売/購入または登録/入札に参加する。",
  rules37: "第七条取引証拠金です",
  rules38:
    "売買家は取引センターの要求によって相応の取引証拠金を納めなければならなくて、取引が成功した後、証拠金は代金を差し引きます。",
  rules39: "第八条保証金の払い戻し",
  rules40:
    "返却条件に該当する場合は、通常2営業日以内に元のルートから入金口座が戻ってきます。",
  rules41: "第九条保証金減額",
  rules42:
    "出品者が発表した商品がオークションに落札された場合、次のいずれかの場合、落札額に相当する保証金が減額され、保証金が不足した場合は納付金全額が減額されます。",
  rules43: "1.受渡し商品の品質と説明が深刻に一致していません;",
  rules44: "2.規定の時間と手続きによって、貨物の受渡しを完了していません。",
  rules45: "3.競売の公示価格によって契約を履行していません。",
  rules46:
    "4.センターは出来高に相当する保証金を控除し、保証金が足りない場合は納付した全額を控除します。",
  rules47:
    "オークションに落札された場合、次のいずれかに該当する場合、落札額に相当する保証金が減額され、保証金が足りない場合は納付金全額が減額されます。",
  rules48: "1.規定の時間と手続きによって、貨物の受渡しを完了していません。",
  rules49: "2.競売公示価格に従って契約を履行していません。",
  rules50:
    "3.センターは出来高と同じ金額の手付金を差し引き、手付金が足りない場合は差し引きます。",
  rules51: "第十条保証金の使途無効化です",
  rules52:
    "1.オークションは成功したが、購入者がオークション終了後の1自然日(取引の支払期限内)に支払いを完了せず、かつこの取引が交渉回復をサポートしていない場合、購入者が支払った手付金は取引の支払期限終了後に罰せられて売り手に支払われます。",
  rules53:
    "2.オークションは成功したが、購入者がオークション終了後2自然日(取引期限内)に支払いを完了しなかった場合、当該註文が交渉再開期間内に取引再開を申請しなかった場合、購入者が支払った手付金は取引再開期間終了後に罰せられ、販売者に支払われます。",
  rules54:
    "3.オークションは成功したが、購入者がオークション終了後の1自然日(取引の支払期限内)に支払いを完了しなかった場合、当該註文は交渉再開期間内に回復を申請したが売り手に処理されなかったり、再開を拒否されたりした場合、購入者が支払った手付金は取引再開拒否後に罰せられて売り手に支払われます。",
  rules55:
    "4.手付金を支払った売り手が、落札後に購入者に納期を支払わなかった場合、売り手が支払った手付金が罰せられ、購入者に支払われます。",
  rules56: "第十一条罰則保証金サービス料差し引き",
  rules57:
    "1.購入者の違約や違反により、購入者が支払った保証金が販売者に罰則を科された場合、サービス料を払い戻さず、保証金を罰する際に控除する権利があります。",
  rules58:
    "2.売り手が違約したり違反して売り手の納付した保証金が買い手に罰せられなかったため、実際の状況に対して応分の入居保証金を控除します。",
  rules59:
    "3.特別な場合:保証金の返還や差し引きについては、プラットフォームを介して異議申し立てをすることができますが、プラットフォームは、中間者として、公平な調整購入者と販売者の責任を判定するかどうか保証金を返すか、または相応の差し引き処理。",
  rules60: "第12条です",
  rules61:
    "アップロードされた情報は、タイプ、品目の仕様、トン数、入庫時間、漁獲方式、冷凍方式、漁獲海域、販売方式、出荷先、出荷先の写真、出荷先の記述などを含まなければなりません。",
  rules62:
    "商品の供給先の説明:名前、重量の大きさ、等級、野生/養殖、商品の形態(元の条/カット)、規格、冷凍方式、包装状況、定重過ポンドポイントなどの他の補足情報です。",
  rules621: "註文記述:品目、価格、出荷地、インボイス情報などです。",
  rules63: "第13条取引方法及び選択に関する提案",
  rules64:
    "1.ユーザーは自分でプラットフォームに登録して入札したり、出品したりすることができます。",
  rules65:
    "2.遅延:入札終了までのカウントダウン1分以内に誰かが入札した場合、オークションは自動的にその入札時間から3分間遅延し、カウントダウン終了1分前まで誰も入札をしなければ、オークションは終了します。",
  rules66: "注意事項です",
  rules67:
    "仕入れ数のハードルを設けることで、悪質な入札を防ぐことができます。例:貨物1トンの低価格競争です。",
  rules68: "市場価格のトレンドを把握し、スムーズな取引を確保します。",
  rules69: "出荷先の詳細を明確に記録し、取引の品質を確保します。",
  rules70: "出荷先の詳細を明確に記録し、取引の品質を確保します。",
  rules71: "アドバイスを選びます",
  rules72: "価格が下落傾向にあり、予算が限られている場合はお勧めします。",
  rules73:
    "サービス料を節約して、商品の市場の価格に対して正確で長期的に貨物の提案を買うことをコントロールします。",
  rules74:
    "商品の品質が安定しており、市場価格が上升傾向にある場合、荷主は商品の価値を知らないので、より高い価格で販売することをお勧めします。",
  rules75: "サービス料を節約して、価格は明確な心理的な期待の選択があります。",
  rules76: "第三章現物の引き渡しです",
  rules77: "第十四です",
  rules78:
    "センター取引が成功した後、買主は本件の出庫、権益変更及び受渡しなどの件を処理します。",
  rules79: "十五条です",
  rules80:
    "約定履行:成約した後、双方の取引先のいずれか一方が契約を破る行為(証拠金控除の状況に合っている)が現れて、客訴の流れ、証拠金控除を履行する以外、この取引先も取引センターの取引先のブラックリストに入って、影響を及ぼしたり後続取引に参与することを制限します。",
  rules81: "第四章附則です",
  rules82: "第十六条です",
  rules83:
    "この規則の解釈と改正は世界の水産物取引プラットフォームが所有しています。",
  rules84: "第十七条です",
  rules85:
    "世界の大口水産物取引所は取引所の需要に応じて保証金規則の改訂と調整を行う権利があり、改訂された規則はサイト内の情報、ウェブサイトの公示など適切な方法でユーザーに通知されます。ユーザーが手付金ルールの改訂後も引き続き本取引プラットフォームを利用し、手付金を支払った場合、ユーザーは改訂後の手付金ルールを完全に理解して受け入れたものとみなされ、本取引プラットフォームが改訂後のルールに従ってユーザーが支払った手付金を管理することに同意します。",
  rules86: "第十八条です",
  rules87:
    "この規則で発生した争議は各当事者が友好的に協議して解決しなければなりません。協議で解決できない場合は、各当事者は争議事項を関系仲裁部門に提出し、仲裁申請時に当該院の現行有効な仲裁規則に従って仲裁を行います。仲裁裁決は終局であり,各当事者に対して拘束力があります。",
  rules88: "第19条です",
  rules89:
    "この規則の解釈と執行はすべて中国大陸地区の法律を適用して、この規則のいかなる条項が無効と認定されるのは他の条項の効力に影響しません。",
  rules90: "第二十条です",
  rules91: "この規則は公布の日から施行します。",
  contact1: "電話です：400-101-2799",
  contact2: "メールボックスです：mail@huacaizhaoyu.com",
  contact3: "住所:北京市朝陽区八里荘陳家林9号院華騰世紀総部公園E1座601A",
  contact4: "掃いてみます",
  contact5: "ウィジェットを見ます",
  contact6: "関心を持ちます",
  contact7: "ウィーチャット公式アカウント",
  indexnew1:
    "世界のハイエンド水産物のオンライン取引プラットフォームを構築します",
  indexnew2:
    "深圳市政府の承認を経て、中国農業発展集団と深圳港集団が共同で発起し、北京華採が技術支援を提供します。深セン国家遠洋漁業基地の先導プロジェクトとして運営に入ります。",
  indexnew3: "標準化された格付け価格システムです",
  indexnew4: "品管理専門チームです",
  indexnew5: "AI技術です",
  indexnew6: "源をたどれます",
  indexnew7: "受渡しシステムです",
  indexnew8: "受渡し倉庫ネットワークです",
  indexnew9: "信用システムです",
  indexnew10: "顧客格付けです",
  indexnew11: "プラットフォーム保証です",
  delivery1: "世界大口水産物取引プラットフォーム世界受渡し倉です",
  delivery2: "グローバルな受渡しサービスを提供しています",
  delivery3:
    "グローバル受渡し倉には、トレーディングセンターにある受渡し倉と、国内外のパートナーと共同で建設した受渡し倉が含まれ、マグロの主な生産地域と消費地域の重要な都市と港をカバーしています。",
  delivery4: "国際化、標準化、専門化、ブランド化です",
  delivery5:
    "世界の受渡し倉の建設と発展は、センターのマグロのために、より便利で、効率的で、安全で、信頼性の高い受渡しサービスを提供し、センターの国際的な影響力と知名度を拡大します。",
  delivery6: "国内外のパートナーとの連携を強化します。",
  delivery7:
    "トレーディングセンターは引き続き国内外のパートナーとの協力を強化し、全世界の受渡し倉のネットワークとカバー範囲を拡大していきます。",
  delivery8: "沿岸の主要集散地をカバーしています",
  delivery9:
    "国内の主要な沿海集散地の都市をカバーします:大連、青島、舟山、福州、深セン、高雄など;中国と東アジア地域をカバーします:東京、釜山、バンコクなど;",
  delivery10:
    "深セン国際マグロ取引センター世界受渡し倉庫とは、センターが世界規模で構築した受渡し倉庫のネットワークであり、センターのマグロにグローバルな受渡しサービスを提供することを目的としています。グローバル受渡し倉には、トレーディングセンターにある受渡し倉と、国内外のパートナーと共同で建設した受渡し倉が含まれ、マグロの主な生産地域と消費地域の重要な都市と港をカバーしています。",
  delivery11:
    "世界的な受渡し倉庫の建設と開発は、トレーディングセンターの「国際化、規範化、専門化、ブランド化」の発展戦略の重要な一部です。世界の受渡し倉の建設と開発は、センターのマグロのために、より便利で、効率的で、安全で、信頼性の高い受渡しサービスを提供することができ、センターの国際的な影響力と認知度を拡大します。",
  delivery12:
    "現在、交易センターはすでに国内の主要な沿海集散地の都市で多くの業界のトップ企業と机関と意向協力関系を創立しました。今後、トレードセンターは国内外のパートナーとの協力を強化し、世界の受渡し倉のネットワークとカバー範囲を拡大し、受渡しサービスの質と効率を向上させ、顧客により良いサービスとより便利な受渡し方法を提供していきます。",
  delivery13: "受渡し倉ネットワーク段階の建設発展計画です:",
  delivery14:
    "第1段階:中国の主要沿海集散地の都市をカバーします:大連、青島、舟山、福州、深セン、高雄など;",
  delivery15:
    "第2段階:中国と東アジア地域をカバーします:東京、釜山、バンコクなど;",
  delivery16: "第3段階:一帯一路国家の主要集散地都市をカバーします。",
  rksj: "入庫時間です",
  szjg: "深セン価格です。",
  nian: "ねんです",
  yue: "げつ",
  zajzzz: "ロード中です",
  flllll: "分類します",
  xia: "フルコースコールドチェーン",
  xue: "タラ",
  zhgll: "アカウント関連です",
  ztzh1: "メインアカウントです",
  dqdlzh1: "(現在の登録アカウントです)",
  yglfh1: "サブ番号に繫がりました",
  xz1: "新たに増えます",
  bzmc1: "注記名です",
  cz1: "操作します",
  tjxgbz: "備考の追加・修正です",
  dqzhybgl: "現在のアカウントに紐付けてあります。",
  ryywqlx: "ご質問がございましたら、ご連絡ください",

  glzh1: "関連アカウントです",
  qsrxygldsjh: "必要な携帯番号の入力をお願いします。",
  qsrbz1: "備考(8文字以内)をご入力願います。",
  dqgldsjh1: "現在つながっている携帯電話番号です",
  glcg: "成功しました",
  cczjyjscsfjx: "この操作は永久に削除されます。継続しますか?",
  tss1: "ヒントです"
};



// WEBPACK FOOTER //
// ./src/lang/ja.js